import React from 'react';
import { DialogRoot, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogCloseTrigger } from '../../ui/dialog';
import { Flex } from '@chakra-ui/react';
import ZoomableImage from '../ZoomableImage';

const ImagePreviewDialog = ({
  isOpen,
  onOpenChange,
  selectedImage,
  title,
  defaultTitle = 'Image Preview',
  width = '60vw',
  height = '60vh',
  showHeader = true,
  bgColor,
  borderColor,
}) => {
  const displayTitle = title || selectedImage?.name || defaultTitle;

  return (
    <DialogRoot
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        placement="center"
        portalled
        backdrop
        bg={bgColor}
        borderColor={borderColor}
        sx={{
          width: width,
          height: height,
          maxWidth: width,
          maxHeight: height,
          p: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {showHeader && (
          <DialogHeader>
            <Flex justify="space-between" align="center" width="100%">
              <DialogTitle>{displayTitle}</DialogTitle>
              <DialogCloseTrigger />
            </Flex>
          </DialogHeader>
        )}

        <DialogBody sx={{ flex: 1, p: 0, bg: 'gray.50' }}>
          {selectedImage && (
            <ZoomableImage selectedImage={selectedImage} />
          )}
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

export default ImagePreviewDialog;
